import Cookies from 'js-cookie'
import { USER_INFO, COOKIE_EXPIRES as expires } from '@/config/'

// 获取基本信息
function setUserInfo (info) {
    return Cookies.set(USER_INFO, Object.assign(info, {
        status: getUserStatus()
    }), {
        expires
    })
}
// 存储基本信息
function getUserInfo () {
    const info = Cookies.getJSON(USER_INFO) || {}
    return Object.assign(info, {
        status: getUserStatus()
    })
}
// 退出登录，清除所有登录信息
function logout () {
    Cookies.remove(USER_INFO)
    Cookies.remove('token')
}

function setToken (str) {
    return Cookies.set('token', str, {
        expires
    })
}

function getToken () {
    return Cookies.get('token')
}

function setUserStatus (status) {
    sessionStorage.setItem('userStatus', status)
}

function getUserStatus () {
    let status = false
    try {
        status = JSON.parse(sessionStorage.getItem('userStatus'))
    } catch (error) {
      
    }
    return status | 0
}

export {
    setToken,
    getToken,
    setUserInfo,
    getUserInfo,
    logout,
    setUserStatus,
    getUserStatus
}